import { Col, Row } from "antd";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "../../../../../../contexts/AuthContext";
import query from "../../../../../../server/constants.api";
import logger from "../../../../../../server/server";
import useFetch from "../../../../../../server/useFetch";
import { PageContent } from "../../../../../../styles/global/Pages.styled";
import { orbitCamera } from "../../../../../../utils/renders/render-helper";
import { Widget } from "../../../../Atomics/Widget";
import { FloorVacancyComponent } from "../../../FloorVacancyComponent/FloorVacancyComponent";
import { StackedFloorsComponent } from "../../../StackedFloorsComponent/StackedFloorsComponent";

// Componente principal que exibe o histórico de consumo energético de um edifício
export const BuildingOccupationDA = ({ item, currentFloor, ...props }) => {
  // Hook de tradução
  const { t } = useTranslation();
  const { user, tenant } = useAuthContext();
  const [orbitCameraVal, setOrbitCamera] = useState(false);
  const [orbitControls, setOrbitControls] = useState();

  useEffect(() => {
    logger.info("User: " + user?.Username + " entered BuildingOccupationDA successfully! Tenant: " + tenant);
  }, [])

  function toggleCamera() {
    orbitCamera(orbitControls, !orbitCameraVal);
    setOrbitCamera(!orbitCameraVal);
  };

  const { data: occupationsReservationsCurrentData, isFetching: occupationsReservationsCurrentIsFetching, refetch: refetchOccupationsReservationsCurrent
  } = useFetch("/registry/occupation/reservations/current", "occupationsReservationsCurrent", {
    buildingID: item.id === currentFloor.value ? item.id : null,
    floorID: !(item.id === currentFloor.value) ? currentFloor?.value : null
  }, currentFloor?.value ?? false, null, query.middlewareURL);

  const { data: occupationsRealTimeData, isFetching: occupationsRealTimeIsFetching, refetch: refetchOccupationsRealTime
  } = useFetch("/registry/occupation/current", "occupationsRealTime", {
    buildingID: item.id === currentFloor.value ? item.id : null,
    floorID: !(item.id === currentFloor.value) ? currentFloor?.value : null
  }, currentFloor?.value ?? false, null, query.middlewareURL);

  const { data: occupationsPeopleFlowData, isFetching: occupationsPeopleFlowIsFetching, refetch: refetchOccupationsPeopleFlow
  } = useFetch("/registry/occupation/people-flow", "occupationsPeopleFlow", {
    buildingID: item.id === currentFloor.value ? item.id : null,
    floorID: !(item.id === currentFloor.value) ? currentFloor?.value : null
  }, currentFloor?.value ?? false, null, query.middlewareURL);

  useEffect(() => {
    refetchOccupationsReservationsCurrent();
    refetchOccupationsRealTime();
  }, [currentFloor?.value]);

  return (
    <PageContent className={clsx("building_room_details", props?.className)}>
      <Row gutter={[16, 16]}>
        {/* Define o layout de linhas com largura total */}
        <Col span={24} style={{ alignContent: "center" }}>
          <Row>
            <Col span={10}>
              <Row>
                <Col span={24}>
                  <h3>
                    {item?.name} | {t("Occupation").toLocaleUpperCase()}{" "}
                    {/* Changes the title to upperCase and translates it */}
                  </h3>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>

        {/* Widgets com dados de consumo energético */}
        <Col span={24}>
          <Row gutter={[16, 16]}>
            <Col span={10}>
              <Widget
                className="full-h"
                data={{
                  background: "white",
                  title: t("Occupation Map"),
                  icon: null,
                  buttons: [{ key: t("360"), title: t("360º"), onButtonClick: () => toggleCamera(), isActive: orbitCameraVal }]
                }}
              >
                <div style={{ height: "320px" }}>
                  {currentFloor?.value === item?.id ? <StackedFloorsComponent building={item} metric={"occupation"} setOrbitControls={setOrbitControls} /> :
                    <FloorVacancyComponent building={item} currentFloor={currentFloor} metric={"occupation"} setOrbitControls={setOrbitControls} />}
                </div>
              </Widget>
            </Col>
            <Col span={14}>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Row gutter={[16, 16]}>
                    <Col span={6}>
                      <Widget
                        className="full-h"
                        data={{
                          background: "white",
                          title: t("Total Reservations"),
                          icon: null,
                          tooltip: t("Percentage reflects bookings in relation to the number of seats available"),
                          charts: [
                            {
                              chartType: "bigNumberChart",
                              chartId: "bigNumberChartOne",
                              height: "80px",
                              isFetching: occupationsReservationsCurrentIsFetching,
                              data: occupationsReservationsCurrentData ? {
                                number: occupationsReservationsCurrentData.deskReservations,
                                unit: '(' + (occupationsReservationsCurrentData.deskReservations * 100 / occupationsReservationsCurrentData.maxDeskOccupation).toPrecision(1) + '%)'
                              } : null,
                            },
                          ],
                        }}
                      />
                    </Col>
                    <Col span={6}>
                      <Widget
                        className="full-h"
                        data={{
                          background: "white",
                          title: t("Check-ins Done"),
                          icon: null,
                          charts: [
                            {
                              chartType: "bigNumberChart",
                              chartId: "bigNumberChartOne",
                              height: "80px",
                              isFetching: occupationsReservationsCurrentIsFetching,
                              data: occupationsReservationsCurrentData ? { number: occupationsReservationsCurrentData.deskCheckIns } : null,
                            },
                          ],
                        }}
                      />
                    </Col>
                    <Col span={6}>
                      <Widget
                        className="full-h"
                        data={{
                          background: "white",
                          title: t("Check-outs Missing"),
                          icon: null,
                          charts: [
                            {
                              chartType: "bigNumberChart",
                              chartId: "bigNumberChartOne",
                              height: "80px",
                              isFetching: occupationsReservationsCurrentIsFetching,
                              data: occupationsReservationsCurrentData ? { number: occupationsReservationsCurrentData.deskCheckOutsMissing } : null,
                            },
                          ],
                        }}
                      />
                    </Col>
                    <Col span={6}>
                      <Widget
                        className="full-h"
                        data={{
                          background: "white",
                          title: t("Real Occupation"),
                          icon: null,
                          charts: [
                            {
                              chartType: "bigNumberChart",
                              chartId: "bigNumberChartOne",
                              height: "80px",
                              isFetching: occupationsRealTimeIsFetching,
                              data: occupationsRealTimeData ? { number: occupationsRealTimeData.openSpaceOccupation } : null,
                            },
                          ],
                        }}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <Widget
                    data={{
                      background: "white",
                      title: t("Distribution of people by floor"),
                      icon: null,
                      charts: [
                        {
                          chartType: "columnsChartApex",
                          chartId: "columnsChartApexOne",
                          height: "210px",
                          isFetching: occupationsRealTimeIsFetching,
                          data: occupationsRealTimeData?.peopleDistribution ? sereializeDistribuitionPeopleFloor(occupationsRealTimeData.peopleDistribution, t) : null,
                        },
                      ],
                    }}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          {/* TODO: Rever este marginTop, tentar por na logica de Row e Col */}
          <Row gutter={[16, 16]} style={{ marginTop: '20px' }}>
            <Col span={20}>
              <Widget
                data={{
                  background: "white",
                  title: t("Distribution throughout the day"),
                  icon: null,
                  charts: [
                    {
                      chartType: "basicLineChartApex", // Tipo do gráfico
                      chartId: "basicLineChartApex", // ID do gráfico
                      height: "392px",
                      data: occupationsPeopleFlowData ? serealizePeopleFlowDayDistribution(occupationsPeopleFlowData, t) : null,
                    },
                  ],
                }}
              />
            </Col>
            <Col span={4}>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Widget
                    className="full-h"
                    data={{
                      background: "white",
                      title: t("Room Reservation"),
                      icon: null,

                      charts: [
                        {
                          chartType: "bigNumberChart",
                          chartId: "bigNumberChartOne",
                          height: "80px",
                          isFetching: occupationsReservationsCurrentIsFetching,
                          data: occupationsReservationsCurrentData ? {
                            number: occupationsReservationsCurrentData.roomReservations,
                            unit: '(' + (occupationsReservationsCurrentData.roomReservations * 100 / occupationsReservationsCurrentData.totalRooms).toFixed(1) + '%)'
                          } : null,
                        },
                      ],
                    }}
                  />
                </Col>
                <Col span={24}>
                  <Widget
                    className="full-h"
                    data={{
                      background: "white",
                      title: t("Check-ins Ongoing"),
                      icon: null,

                      charts: [
                        {
                          chartType: "bigNumberChart",
                          chartId: "bigNumberChartOne",
                          height: "80px",
                          isfetching: occupationsReservationsCurrentIsFetching,
                          data: occupationsReservationsCurrentData ? { number: occupationsReservationsCurrentData.roomCheckIns } : null,
                        },
                      ],
                    }}
                  />
                </Col>
                <Col span={24}>
                  <Widget
                    className="full-h"
                    data={{
                      background: "white",
                      title: t("Real Occupation"),
                      icon: null,
                      charts: [
                        {
                          chartType: "bigNumberChart",
                          chartId: "bigNumberChartOne",
                          height: "80px",
                          isFetching: occupationsRealTimeIsFetching,
                          data: occupationsRealTimeData ? { number: occupationsRealTimeData.roomsOccupation } : null,
                        },
                      ],
                    }}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </PageContent >
  );
};

const sereializeDistribuitionPeopleFloor = (data, t) => {
  const series = [
    {
      "name": t("Real"),
      "data": []
    },
    {
      "name": t("Extended Reservations"),
      "data": []
    }
  ];

  Object.entries(data).map((entry, index) => {
    const [key, value] = entry;

    series[0].data.push({
      x: t(key.split('.')[0]),
      y: value.realOccupancy,
      order: key.split('.')[0]
    })

    series[1].data.push({
      x: t(key.split('.')[0]),
      y: value.reservations,
      order: key.split('.')[0]
    })
  });

  // Ordenar os dados pela chave 'order'
  const sortedSeries = series.map(seriesItem => ({
    ...seriesItem,
    data: seriesItem.data.sort((a, b) => a.order.localeCompare(b.order))
  }));

  return {
    "series": sortedSeries,
    "categories": [],
    // "xAxisType": "",
    "labelFormat": "",
    "tooltip": null,
    "unit": "",
    "columnWidth": 10,
    "xAxisLabel": null,
    "yAxisLabel": "",
    "color": null,
    "formatterType": null,
    // "tickAmount": 1,
    "filename": "Gráfico exportado",
    "headerValue": "valores",
    "headerCategory": "categorias",
    "showTooltipTitle": false,
    "strokeWidth": 2,
    // "xaxisLabelHide": true
  }
}

const serealizePeopleFlowDayDistribution = (data, t) => {
  let series = [
    {
      "name": t("Occupation"),
      "data": []
    }
  ];

  Object.entries(data).map((entry, index) => {
    const [key, value] = entry;

    series[0].data.push({
      x: t(key.split('-')[0].split(':')[1]).slice(0, -1) + ':00',
      y: value.occupation
    })
  });

  const sortedData = series[0].data.sort((a, b) => {
    if (a.x.length < b.x.length) {
      return -1;
    }
    if (a.x.length > b.x.length) {
      return 1;
    }
    if (a.x < b.x) {
      return -1;
    }
    if (a.x > b.x) {
      return 1;
    }
    return 0;
  });
  series[0].data = sortedData;
  return {
    "series": series,
    "categories": [],
    // "xAxisType": "",
    "labelFormat": "",
    "tooltip": null,
    "unit": "",
    "columnWidth": 10,
    "xAxisLabel": null,
    "yAxisLabel": "",
    "color": null,
    "formatterType": null,
    // "tickAmount": 1,
    "filename": "Gráfico exportado",
    "headerValue": "valores",
    "headerCategory": "categorias",
    "showTooltipTitle": false,
    "strokeWidth": 2,
    // "xaxisLabelHide": true
  }
}